module.exports = __webpack_public_path__ + "static/img/logo-origo-white.742726f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-origo-white.png
// module id = 1PNk
// module chunks = 39